import { RefObject } from 'react';

export enum SidePanelType {
  Accounts = 'accounts',
  Customers = 'customers',
  AML = 'aml',
  Transactions = 'transactions',
  Cards = 'cards',
  Exchange = 'exchange',
  Fees = 'fees',
  Responsive = 'responsive',
  Expand = 'expand',
}

export enum FooterContentPosition {
  Right = 'position-right',
  Left = 'position-left',
  Center = 'position-center',
}

export interface SidePanelLoaderTypes {
  className?: string;
}

export interface SidepanelDefaultRowTypes {
  title?: string;
  children?: React.ReactNode | string | number;
  wrapperClassName?: string;
  titleClassName?: string;
  valueClassName?: string;
}

export interface SidePanelRowTypes {
  caption?: string;
  resultBlock?: boolean;
  children: React.JSX.Element | React.JSX.Element[] | string;
}

export interface SidePanelTypes {
  isOpen: boolean;
  onClose: () => void;
  children: React.JSX.Element;
  footer?: React.JSX.Element;
  title: string | React.JSX.Element;
  closeOnClickOutside: boolean;
  footerContentPosition?: FooterContentPosition;
  type?: SidePanelType;
  parent?: HTMLElement;
  className?: string;
  footerVisible?: boolean;
  childrenRef?: RefObject<HTMLDivElement | null>;
  errorSidepanel?: string | string[];
  checkInProgress?: boolean;
  transactionCheckError?: string;
  checkText?: string;
  onExpandClick?: () => void;
  sidepanelExpandedKey: string;
  withoutExpand?: boolean;
  expanded?: boolean;
}
